<template>
    <div style="display: contents" class="base-pagination-container">
        <slot name="content" :paginatedData="paginatedData"></slot>
        <slot
            name="paginator"
            :totalPages="totalPages"
            :currentPage="currentPage"
            :paginatedPages="paginatedPages"
            :nextPage="nextPage"
            :prevPage="prevPage"
        ></slot>
    </div>
</template>
<script>
    import { usePagination } from '@/composables/ui/usePagination'
    export default {
        name: 'BasePagination',
        props: {
            maxData: {
                type: Number,
                required: true
            },
            data: {
                type: Array,
                required: true
            }
        },
        setup(props) {
            const {
                totalPages,
                currentPage,
                paginatedData,
                paginatedPages,
                nextPage,
                prevPage
            } = usePagination(props)

            return {
                totalPages,
                currentPage,
                paginatedData,
                paginatedPages,
                nextPage,
                prevPage
            }
        }
    }
</script>
